/* eslint-disable no-param-reassign */
import { useEffect } from 'react';

import PatientModel from 'jsx/models/patient/patient';
import CONFIG from 'jsx/constants/config';

declare global {
  interface Window {
    duet?: {
      open(): void;
      setMetadata: (metadata: {
        email?: string;
        name?: string;
        path?: string;
      }) => void;
      setUserId: (userId: string) => void;
    };
  }
}

const decagonIframeLoaded = (
  brand: string,
  callback: (decagonIframe: HTMLElement) => void,
) => {
  setTimeout(() => {
    if (typeof document !== 'undefined') {
      const decagonIframe = document.querySelector(
        `[src="https://decagon.ai/demo/${brand}"]`,
      );

      if (decagonIframe) {
        decagonIframe.addEventListener('load', () =>
          callback(decagonIframe as HTMLElement),
        );
      } else {
        decagonIframeLoaded(brand, callback);
      }
    }
  }, 50);
};

export const useDecagonChatBot = (patient?: PatientModel) => {
  const brand = window.CUROLOGY_ENV.APP_BRAND ?? patient?.brand;

  useEffect(() => {
    // We only want this to run once.
    if (
      !!document.getElementById('decagon-script') ||
      !brand ||
      !patient ||
      CONFIG.isTestEnv
    ) {
      return;
    }

    const script = document.createElement('script');
    script.setAttribute('id', 'decagon-script');
    script.src = `https://decagon.ai/loaders/${brand}.js`;
    script.async = true;

    document.body.appendChild(script);
  }, [brand, patient]);

  decagonIframeLoaded(brand, (decagonIframe: HTMLElement) => {
    if (patient) {
      window.duet?.setMetadata({
        email: patient.email,
        name: patient.fullName,
        path: window.location.pathname,
      });

      window.duet?.setUserId(String(patient.id));
    }

    decagonIframe.style.bottom = '60px';
    decagonIframe.style.maxHeight = 'calc(100dvh - 60px)';

    // Allow modals to be above chatbot, otherwise, scrolling breaks in iOS.
    decagonIframe.style.zIndex = '999994';
  });
};
